import React, { useRef, useState } from "react";
import { Link, Redirect, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/auth";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import useOnceEffect from "../Hooks/useOnceEffect";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Acceso() {
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [rol, setRol] = useState("");
  const { setAuthTokens } = useAuth();
  const loginTimes = useRef(0);
  const timeSkip = useRef(false);

  let query = useQuery();

  useOnceEffect(() => {
    if (query.get("validateduser") !== null) {
      query.get("validateduser") === "t"
        ? toast.success(
            "Usuario activado exitosamente, favor ingrese sus credenciales",
            { duration: 6000 }
          )
        : toast.error(
            "Tokén inválido, por favor ingrese con el enlace que se le envió a su correo",
            {
              duration: 6000,
            }
          );
    }
    localStorage.clear();
  });

  function postLogin(values) {
    //evita que se ejecute esta funcion, si aun
    // no ha finalizado de ejecutarse la vez pasada
    if (timeSkip.current) return;

    if (loginTimes.current >= 3) {
      toast.error(
        "Se han hechos muchos intentos de acceso fallido, vuelva a intentarlo en 5 minutos."
      );

      setTimeout(() => {
        loginTimes.current = 0;
      }, 1000 * 60 * 5);

      return;
    }

    timeSkip.current = true;
    loginTimes.current = loginTimes.current + 1;

    axios.defaults.headers.common["Authorization"] = null;
    axios
      .post("auth/signin", {
        password: values.password,
        username: values.username,
      })
      .then((result) => {
        if (result.status === 200) {
          toast.dismiss();
          setAuthTokens(result.data);
          setRol(result.data.rol[0]);
          localStorage.setItem("tok", result.data.accessToken);
          localStorage.setItem("userId", result.data.id);
          localStorage.setItem("username", result.data.username);
          localStorage.setItem("rol", result.data.rol);

          axios.defaults.headers.common["Authorization"] =
            "Bearer " + result.data.accessToken;

          setLoggedIn(true);
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      })
      .catch((e) => {
        if (e.message === "Network Error") {
          return toast.error("Error de Conexión", {
            duration: 6000,
          });
        }
        if (!e.status) {
          toast.error(e.response?.data?.message, { duration: 10000 });
        } else {
          toast.error(e.response?.data?.message, {
            duration: 6000,
          });
        }
      })
      .finally(() => (timeSkip.current = false));
  }

  if (isLoggedIn) {
    switch (rol) {
      case "applicant":
        return <Redirect to="/user/Home" />;
      case "company":
        return <Redirect to="/company/Home" />;
      case "institute":
        return <Redirect to="/CentroFormacion/Home" />;

      case "admin":
        return <Redirect to="/admin/home" />;
      // case "student":
      //   return <Redirect to="/PaginaPrincipal" />;
      default:
        return <Redirect to="/" />;
    }
  }

  const Validaciones = Yup.object().shape({
    username: Yup.string().required(""),
    password: Yup.string().required(""),
  });

  function mostrarPassword() {
    var cambio = document.getElementById("password");
    cambio.type === "password"
      ? (cambio.type = "text")
      : (cambio.type = "password");
  }

  return (
    <div className="login">
      <Toaster />
      <div className="container">
        <div className="row">
          <div className="col-sm-12 align-div--middle">
            <div className="login__content-wrapper">
              <div className="logo">KREZCO</div>
              <div className="form form--login form--white form--bordered">
                <Formik
                  initialValues={{
                    username: "",
                    password: "",
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    postLogin(values);
                    setSubmitting(false);
                  }}
                  validationSchema={Validaciones}
                >
                  {({ isSubmitting }) => (
                    <Form>
                      <div className="form__wrapper">
                        <div className="form__row">
                          <label htmlFor="username">Usuario o Correo</label>
                          <Field
                            type="text"
                            name="username"
                            id="username"
                            required
                          ></Field>
                          <span className="form__validation"></span>
                        </div>
                        <div className="form__row">
                          <label htmlFor="password">Contraseña</label>
                          <Field
                            type="password"
                            name="password"
                            id="password"
                            required
                          ></Field>
                          <i
                            className="fa fa-eye-slash password-icon"
                            onClick={mostrarPassword}
                          />
                          <span className="form__validation"></span>
                        </div>
                        <div className="form__row">
                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className="btn btn--gradient btn__icon btn__icon--door !bg-gradient-to-r from-[#9100ff] to-[#4b00ff]"
                          >
                            <i className="fas fa-sign-in"></i> Acceder
                          </button>
                        </div>
                        <div className="form__row form__footer row">
                          <div className="col-8 col-md-6">
                            <input
                              type="checkbox"
                              name="rememberpw"
                              id="rememberpw"
                            ></input>
                            <label htmlFor="rememberpw">
                              Recordar mi contraseña
                            </label>
                          </div>
                          <div className="col-4 col-md-6 text-end">
                            <Link to="/ResetPassword" className="link">
                              Olvidé mi contraseña
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
              <div
                className="regular-content text-color--white text-center pt-4"
                style={{ fontSize: "18px" }}
              >
                ¿Aún no tienes una cuenta?{" "}
                <Link to="/Registrate" className="link-color--purple">
                  Forma parte de la comunidad KREZCO
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Acceso;
